import { render, staticRenderFns } from "./coursebuttons.vue?vue&type=template&id=1b1ca22e&"
import script from "./coursebuttons.vue?vue&type=script&lang=js&"
export * from "./coursebuttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports